import React, { useState, useEffect } from 'react';
import {
    Card,
    Table,
    Button,
    Form,
    Row,
    Col,
    Spinner,
    Pagination,
    Badge,
    InputGroup
} from 'react-bootstrap';
import Header from '../../layouts/Header';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axiosInstance from '../../api/axios';import { ArrowLeft, FileEarmarkSpreadsheet } from 'react-bootstrap-icons';
import OutletSelect from '../../components/OutletSelect';

const StockConsumptionReport = () => {
    const currentSkin = localStorage.getItem("skin-mode") ? "dark" : "";
    const [skin, setSkin] = useState(currentSkin);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [downloadBtnLoading, setDownloadBtnLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(25);
    const [totalPages, setTotalPages] = useState(1);
    const [totalDocuments, setTotalDocuments] = useState(0);

    // Filter states
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectedOutlet, setSelectedOutlet] = useState('');
    const [selectedTransactionType, setSelectedTransactionType] = useState('');
    const [selectedOutetName, setSelectedOutetName] = useState('');
    const [error, setError] = useState('');
    const [clicked, setClicked] = useState(false);

    // Data states
    const [allStockReportData, setAllStockReportData] = useState([]);
    const [stockReportData, setStockReportData] = useState([]);
    const [rmMaincategoryList, setRmMaincategoryList] = useState([]);
    const [selectedRMCategory, setSelectedRMCategory] = useState('');
    const [rawMaterialList, setRawMaterialList] = useState([]);

    // Dropdown options
    const [outletOptions, setOutletOptions] = useState([]);

    const accessToken = localStorage.getItem("authToken");

    const transactionTypeOptions = [
        { value: '', label: 'All Transaction Types' },
        { value: 'SALE', label: 'Sale' },
        { value: 'DAMAGE', label: 'Damage' },
    ];

    const options = rmMaincategoryList?.map((rmcat) => ({
        value: rmcat?._id,
        label: rmcat?.name,
    }));

    const handleRMCategoryChange = (selectedOption) => {
        const categoryId = selectedOption ? selectedOption.value : '';
        setSelectedRMCategory(categoryId);
        // if (categoryId) {
        //     getRawMaterials(categoryId);
        // } else {
        //     setRawMaterialList([]);
        // }
    };

    // Fetch initial data on component mount
    useEffect(() => {
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
        getRawMaterialsMainCategory();
        fetchOutlets();
    }, []);

    const fetchOutlets = async () => {
        try {
            const response = await axiosInstance.get('outlet', {
                headers: {
                    Authorization: `Bearer ${accessToken}`
                }
            });
            const outlets = response.data.data?.outlets?.map(outlet => ({
                value: outlet?._id,
                label: `${outlet?.name} (${outlet?.city})`
            }));
            setOutletOptions(outlets);
        } catch (error) {
            console.error('Error fetching outlets:', error);
        }
    };

    const getRawMaterialsMainCategory = async () => {
        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`,
            };
            const response = await axiosInstance.get("masters/rm-main-category/get", {
                headers,
            });

            if (response?.data?.status === true) {
                setRmMaincategoryList(response?.data?.data?.categories);
            }
        } catch (error) {
            if (error.response && error.response?.data?.status === false) {
                let errorMessage = error.response.data.error;
                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "colored",
                });
            }
        }
    };

    const handleSubmit = async (e) => {
        e?.preventDefault();
        setClicked(true);
        setCurrentPage(1);

        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));

        getAllStockReport(1, recordsPerPage, false, false, adjustedStartDate, adjustedEndDate, selectedTransactionType, selectedRMCategory);
    }

    const getAllStockReport = async (page = 1, limit = recordsPerPage, download = false, isRawMaterial = false, start = startDate, end = endDate, tranType, main) => {
        if (download || isRawMaterial) {
            setDownloadBtnLoading(true);
        } else {
            setLoading(true);
        }

        try {
            const headers = {
                Authorization: `Bearer ${accessToken}`
            }

            let url = `stock-transactions/getDebitOutletStockTransactions?startDate=${start.toISOString().split("T")[0]}&endDate=${end.toISOString().split("T")[0]}`

            // let url = `stock-transactions/getOutletStockTransactions?startDate=${start.toISOString().split("T")[0]}&endDate=${end.toISOString().split("T")[0]}&transactionType="SALE"`

            if (selectedOutlet) {
                url += `&outletId=${selectedOutlet?.value}`;
            }

            if (main) {
                url += `&mainCategory=${main}`
            }

            if (tranType) {
                url += `&transactionType=${tranType}`
            }

            // if (selectedTransactionType) {
            //     url += `&type=${selectedTransactionType}`;
            // }

            // Add pagination parameters if not downloading
            if (!download && !isRawMaterial) {
                url += `&page=${page}&limit=${limit}`;
            }

            if (download) {
                url += `&isDownload=true`
            }

            const response = await axiosInstance.get(url, {
                headers,
                responseType: (download || isRawMaterial) ? 'blob' : 'json'
            });

            console.log("Main Response :", response);



            if (download || isRawMaterial) {
                // Create a blob from the response data
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                });

                // Create a link element
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);

                // Set the filename for the download
                const outletName = selectedOutlet ?
                    outletOptions.find(o => o.value === selectedOutlet)?.label.split('(')[0].trim() || 'Outlet' :
                    'All Outlets';
                const fileName = `${outletName} Stock Transfer Report (${start.toISOString().split("T")[0]} - ${end.toISOString().split("T")[0]}).xlsx`;
                link.download = fileName;

                // Append the link to the body and trigger the download
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(link.href);

                if (!isRawMaterial) {
                    toast.success('Excel file downloaded successfully!', {
                        position: "top-right",
                        autoClose: 3000,
                        theme: "light"
                    });
                }
            } else {
                console.log("Stock Consumption Report  :", response?.data?.data?.outletStockTransactionRecords);

                const data = response?.data?.data?.outletStockTransactionRecords || [];
                setAllStockReportData(data);
                setStockReportData(data);

                // Set pagination data
                if (response?.data?.data?.paginationData) {
                    const { totalDocuments, limit, NumberOfPages, currentPage } = response.data.data.paginationData;
                    setTotalDocuments(totalDocuments);
                    setRecordsPerPage(limit);
                    setTotalPages(NumberOfPages);
                    setCurrentPage(currentPage);
                }

                toast.success("Report generated successfully", {
                    position: "top-right",
                    autoClose: 2000,
                    theme: "light",
                });
            }
        } catch (error) {
            if (error?.response) {
                let errorMessage = "";
                setAllStockReportData([]);
                setStockReportData([]);

                if (error.response?.status === 406) {
                    errorMessage = error?.response?.data?.error?.message || error?.response?.data?.error;
                } else if (error.response?.status === 404) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 412) {
                    errorMessage = error?.response?.data?.data?.message;
                } else if (error.response?.status === 500) {
                    errorMessage = error?.response?.data?.error;
                } else {
                    errorMessage = "An error occurred while fetching the report";
                }

                toast.error(errorMessage, {
                    position: "top-right",
                    autoClose: 3000,
                    theme: "light",
                });
            }
        } finally {
            setLoading(false);
            setDownloadBtnLoading(false);
        }
    };

    const handleDownloadExcel = () => {
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        getAllStockReport(1, recordsPerPage, true, false, adjustedStartDate, adjustedEndDate, selectedTransactionType, selectedRMCategory);
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
        const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
        getAllStockReport(pageNumber, recordsPerPage, false, false, adjustedStartDate, adjustedEndDate, selectedTransactionType, selectedRMCategory);
    };

    const handleEndDateChange = (date) => {
        if (!date || !startDate) {
            setEndDate(date);
            return;
        }

        const start = new Date(startDate);
        const end = new Date(date);

        // Remove time part
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);

        const maxEndDate = new Date(start);
        maxEndDate.setDate(start.getDate() + 60);

        if (end > maxEndDate) {
            setError("End date cannot be more than 60 days after start date");
        } else if (end < start) {
            setError("End date cannot be earlier than start date");
        } else {
            setError('');
            setEndDate(date);
        }
    };


    const clearFilters = () => {
        setSelectedOutlet('');
        setSelectedTransactionType('');
        const now = new Date();
        const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
        const currentDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());

        const start = new Date(firstOfMonth.setHours(23, 59, 59, 999));
        const end = new Date(currentDate.setHours(23, 59, 59, 999));

        setStartDate(start);
        setEndDate(end);
        setCurrentPage(1);
        setSelectedOutetName('');
        setError('');
        setClicked(false);
        setStockReportData([]);
    };

    // Function to handle automatic download when isRawmaterial is true
    const checkAndDownloadIfRawMaterial = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const isRawMaterial = urlParams.get('isRawmaterial') === 'true';

        if (isRawMaterial && startDate && endDate) {
            const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
            const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
            getAllStockReport(1, recordsPerPage, true, true, adjustedStartDate, adjustedEndDate, selectedTransactionType, selectedRMCategory);
        }
    };

    // Check for raw material download when dates are set
    useEffect(() => {
        if (startDate && endDate) {
            checkAndDownloadIfRawMaterial();
        }
    }, [startDate, endDate]);

    // Render pagination items
    const renderPaginationItems = () => {
        const items = [];
        const maxVisiblePages = 5;

        let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

        if (endPage - startPage + 1 < maxVisiblePages) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }

        if (startPage > 1) {
            items.push(
                <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
                    1
                </Pagination.Item>
            );
            if (startPage > 2) {
                items.push(<Pagination.Ellipsis key="start-ellipsis" />);
            }
        }

        for (let i = startPage; i <= endPage; i++) {
            items.push(
                <Pagination.Item
                    key={i}
                    active={i === currentPage}
                    onClick={() => handlePageChange(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }

        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                items.push(<Pagination.Ellipsis key="end-ellipsis" />);
            }
            items.push(
                <Pagination.Item
                    key={totalPages}
                    onClick={() => handlePageChange(totalPages)}
                >
                    {totalPages}
                </Pagination.Item>
            );
        }

        return items;
    };

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className={`main main-app p-3 p-lg-4 ${skin === "dark" ? "bg-dark text-light" : "bg-light"}`}>
                <Card className="shadow-sm border-0">
                    <Card.Header className="bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-0 fw-bold d-inline-block">
                                <i className="bi bi-arrow-left-right me-2"></i>STOCK USAGE REPORT
                            </h4>
                        </div>
                        <div>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                onClick={() => navigate('/reports/all-reports')}
                                className="me-3 d-flex align-items-center fw-semibold"
                                style={{ height: '38px' }}
                            >
                                <ArrowLeft className="me-1" /> Back to Reports
                            </Button>
                        </div>
                    </Card.Header>
                    <hr className='mt-0 mb-0' />

                    <Card.Body>
                        {/* Filters Section */}
                        <div className="p-3 bg-light rounded-3">
                            <Form onSubmit={handleSubmit}>
                                <Row className="g-3">
                                    <Col md={4}>
                                        <Form.Group controlId="outletSelect">
                                            <OutletSelect
                                                value={selectedOutlet}
                                                onChange={(option) => {
                                                    console.log("Selected Outlet :", option);
                                                    setSelectedOutlet(option);
                                                }}
                                                required={true}
                                            />

                                            {/* <Select
                                                options={outletOptions}
                                                value={outletOptions.find(opt => opt.value === selectedOutlet) || null}
                                                onChange={(selected) => {
                                                    setSelectedOutlet(selected?.value || '');
                                                    setSelectedOutetName(selected?.label || '');
                                                }}
                                                isClearable
                                                placeholder="Select Outlet"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            /> */}
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="startDate">
                                            <Form.Label className="fw-semibold">
                                                Start Date <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <DatePicker
                                                selected={startDate}
                                                onChange={(date) => {
                                                    setStartDate(date);
                                                    // Reset endDate if it's outside the new 60-day range
                                                    if (endDate && date && endDate > new Date(date.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                        setEndDate(null);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="Start Date"
                                                className="form-control border-secondary"
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2}>
                                        <Form.Group controlId="endDate">
                                            <Form.Label className="fw-semibold">
                                                End Date <span className='text-danger'>*</span>
                                            </Form.Label>
                                            <DatePicker
                                                selected={endDate}
                                                onChange={(date) => {
                                                    if (startDate && date > new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000)) {
                                                        setError("End date cannot be more than 60 days after start date");
                                                    } else {
                                                        setError("");
                                                        handleEndDateChange(date);
                                                    }
                                                }}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="End Date"
                                                className="form-control border-secondary"
                                                minDate={startDate}
                                                maxDate={startDate ? new Date(startDate.getTime() + 60 * 24 * 60 * 60 * 1000) : null}
                                            />
                                            {error && <div className="text-danger small mt-1">{error}</div>}
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="transactionType">
                                            <Form.Label className="fw-semibold">
                                                Transaction Type
                                            </Form.Label>
                                            <Select
                                                options={transactionTypeOptions}
                                                value={transactionTypeOptions.find(opt => opt.value === selectedTransactionType) || null}
                                                onChange={(selected) => setSelectedTransactionType(selected?.value || '')}
                                                isClearable
                                                placeholder="Select Type"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={4}>
                                        <Form.Group controlId="rmCategory">
                                            <Form.Label className="fw-semibold">
                                                Main RM Category
                                            </Form.Label>
                                            <Select
                                                isClearable
                                                value={options.find(option => option.value === selectedRMCategory)}
                                                onChange={handleRMCategoryChange}
                                                options={options}
                                                placeholder="Select Main RM Categories"
                                                className="border-secondary"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        borderColor: '#6c757d',
                                                        minHeight: '38px'
                                                    })
                                                }}
                                            />
                                        </Form.Group>
                                    </Col>

                                    <Col md={2} className="d-flex align-items-end">
                                        <Button
                                            variant="primary"
                                            type="submit"
                                            className="w-100"
                                            disabled={!startDate || !endDate || !selectedOutlet}
                                        >
                                            {loading ? (
                                                <Spinner size="sm" animation="border" />
                                            ) : (
                                                "Generate"
                                            )}
                                        </Button>
                                    </Col>
                                    
                                    <Col md={3} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-success"
                                            className="w-100 fw-semibold"
                                            onClick={handleDownloadExcel}
                                            disabled={!stockReportData?.length || downloadBtnLoading}
                                        >
                                            <FileEarmarkSpreadsheet className="me-2" />
                                            {downloadBtnLoading ? <Spinner size='sm' /> : 'Download Excel'}
                                        </Button>
                                    </Col>
                                    {/* <Col md={1} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-secondary"
                                            onClick={clearFilters}
                                            className="w-100"
                                        >
                                            Clear
                                        </Button>
                                    </Col> */}
                                </Row>

                                {/* <Row className="g-3 mt-2">
                                    <Col md={3} className="d-flex align-items-end">
                                        <Button
                                            variant="outline-success"
                                            className="w-100 fw-semibold"
                                            onClick={handleDownloadExcel}
                                            disabled={!stockReportData?.length || downloadBtnLoading}
                                        >
                                            <FileEarmarkSpreadsheet className="me-2" />
                                            { downloadBtnLoading ? <Spinner size='sm' /> : 'Download Excel' }
                                        </Button>
                                    </Col>
                                </Row> */}
                            </Form>
                        </div>

                        {/* Results Section */}
                        {!clicked ? (
                            <div className="d-flex justify-content-center align-items-center py-5 my-5 bg-light rounded-3 mt-2">
                                <div className="text-center">
                                    <i className="bi bi-clipboard-data fs-1 text-muted"></i>
                                    <h5 className="text-muted mt-3">
                                        Please select filters to view stock transfer report
                                    </h5>
                                </div>
                            </div>
                        ) : (
                            <>
                                {/* Pagination and Records Per Page - Top */}
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <div className="d-flex align-items-center">
                                        <span className="me-2 text-muted">Show</span>
                                        <Form.Select
                                            style={{ width: 'auto' }}
                                            value={recordsPerPage}
                                            onChange={(e) => {
                                                const selectedRecordsPerPage = Number(e.target.value);
                                                setRecordsPerPage(selectedRecordsPerPage);
                                                setCurrentPage(1);
                                                const adjustedStartDate = new Date(startDate.setHours(23, 59, 59, 999));
                                                const adjustedEndDate = new Date(endDate.setHours(23, 59, 59, 999));
                                                getAllStockReport(1, selectedRecordsPerPage, false, false, adjustedStartDate, adjustedEndDate, selectedTransactionType, selectedRMCategory);
                                            }}
                                            className="border-secondary"
                                        >
                                            <option value={25}>25</option>
                                            <option value={50}>50</option>
                                            <option value={100}>100</option>
                                            <option value={200}>200</option>
                                            <option value={300}>300</option>
                                            <option value={500}>500</option>
                                        </Form.Select>
                                        <span className="ms-2 text-muted">entries</span>
                                    </div>

                                    <Pagination className="mb-0">
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        />
                                        {renderPaginationItems()}
                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                    </Pagination>
                                </div>

                                {/* Stock Transactions Table */}
                                <div className="table-responsive border rounded-3 mt-3">
                                    <Table striped bordered hover className="mb-0">
                                        <thead className="bg-light">
                                            <tr>
                                                <th width="50">#</th>
                                                <th>Financial Year</th>
                                                <th>Raw Material Details</th>
                                                <th>Transaction Type</th>
                                                {/* <th>Main Category</th>
                                                <th>Sub Category</th> */}
                                                <th>HSN</th>
                                                <th>Tax %</th>
                                                <th className="text-center">Quantity</th>
                                                {/* <th>Unit</th> */}
                                                {/* <th>Outlet</th> */}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {loading ? (
                                                <tr>
                                                    <td colSpan="11" className="text-center py-4">
                                                        <Spinner animation="border" variant="primary" />
                                                        <p className="mt-2 mb-0">Loading transactions...</p>
                                                    </td>
                                                </tr>
                                            ) : stockReportData?.length > 0 ? (
                                                stockReportData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td className="text-muted">
                                                            {(currentPage - 1) * recordsPerPage + index + 1}
                                                        </td>
                                                        <td className='text-center'>{item?.financialYear}</td>
                                                        <td >
                                                            <span className="fw-semibold">{item?.rawMaterial?.name}</span>
                                                            <br />
                                                            <span className='text-primary' style={{ fontSize: '12px' }}>{item?.rawMaterial?.mainCategory?.name}</span> {">> "}
                                                            <span className='text-success' style={{ fontSize: '11px' }}>{item?.rawMaterial?.subCategory?.name}</span>
                                                        </td>
                                                        <td className='text-center'>
                                                            <Badge
                                                                bg={item.transactionType === 'DAMAGE' ? 'danger' : 'success'}
                                                                className="px-2 py-1"
                                                            >
                                                                {item.transactionType}
                                                            </Badge>
                                                            <br />
                                                            <span className='text-muted' style={{ fontSize: '12px' }}>[{item?.type}]</span>
                                                        </td>
                                                        {/* <td>{item.mainCategory}</td>
                                                        <td>{item.subCategory}</td> */}
                                                        <td className='text-center'>{item?.rawMaterial?.hsn}</td>
                                                        <td className='text-center'>{item?.rawMaterial?.taxPercent}%</td>
                                                        <td className="text-center fw-semibold">
                                                            {item?.quantity?.toFixed(2)}  {item?.rawMaterial?.unit}
                                                        </td>
                                                        {/* <td>{item.unit}</td> */}
                                                        {/* <td>{item.storageLocation}</td> */}
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="11" className="text-center py-4">
                                                        <i className="bi bi-exclamation-circle fs-4 text-muted"></i>
                                                        <p className="mt-2 mb-0 text-muted">
                                                            No transactions found for the selected criteria
                                                        </p>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>

                                {/* Pagination and Records Per Page - Bottom */}
                                <div className="d-flex justify-content-between align-items-center mt-3">
                                    <div className="text-muted">
                                        Showing {(currentPage - 1) * recordsPerPage + 1} to{' '}
                                        {Math.min(currentPage * recordsPerPage, totalDocuments)} of{' '}
                                        {totalDocuments} entries
                                    </div>
                                    <Pagination>
                                        <Pagination.Prev
                                            disabled={currentPage === 1}
                                            onClick={() => handlePageChange(currentPage - 1)}
                                        />
                                        {renderPaginationItems()}
                                        <Pagination.Next
                                            disabled={currentPage === totalPages}
                                            onClick={() => handlePageChange(currentPage + 1)}
                                        />
                                    </Pagination>
                                </div>
                            </>
                        )}
                    </Card.Body>
                </Card>
            </div>
        </React.Fragment>
    )
}

export default StockConsumptionReport;